export default {
    "dynamicFormsDuplicte_title": "Copy form: ",
    "dynamicFormsDuplicte_duplicate": "Copy",
    "dynamicFormsDuplicte_warning": "Are you sure you want to copy the form? This action will not copy the answers",
}